module.exports = __webpack_public_path__ + "img/ax.2d5bd1b1.svg";